import * as yup from 'yup'

const schema = yup
  .object({
    legalOpinion: yup.string().required().max(1000),
    initialOrientation: yup.string().max(1000),
    confirmed: yup.string().required(),
    shouldNotify: yup.string(),
    shouldNotifyAnpd: yup.string(),
    notificationOpinion: yup.string().when('shouldNotify', {
      is: 'true',
      then: yup.string().required(),
    }),
    opinionFile: yup.mixed().fileUpload({
      fileGroup: 'document',
      sizeLimit: 5,
      required: true,
    }),
    notificationOpinionFile: yup.mixed().fileUpload({
      fileGroup: 'document',
      sizeLimit: 5,
      required: { field: 'shouldNotify', is: 'true' },
    }),
  })
  .required()

export default schema
